import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-comprehensive_chat_csat-submit';

/**
 * Submit CTA to collect chat CSAT feedback in help center
 */
export function trackHelpCenterComprehensiveChatCsatSubmit(
  brandToken: string,
  retailerToken: string,
  Feedback: string,
  CsatReasons2: string,
  TicketId3: string,
  AgentName4: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      brandToken,
      retailerToken,
      Feedback,
      CsatReasons2,
      TicketId3,
      AgentName4,
    },
  });
}
